import { render, staticRenderFns } from "./PolicyHolderDeeplinkView.vue?vue&type=template&id=47e53c9e&scoped=true&"
import script from "./PolicyHolderDeeplinkView.vue?vue&type=script&lang=js&"
export * from "./PolicyHolderDeeplinkView.vue?vue&type=script&lang=js&"
import style0 from "./PolicyHolderDeeplinkView.vue?vue&type=style&index=0&id=47e53c9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e53c9e",
  null
  
)

export default component.exports